export class RegexUtils {
    static clearUrlFromString(_string) {
        var regStr = 'http[s]*://[a-z0-9A-Z.]*' + process.env.GATSBY_WPHOST + '/';
        var reg = new RegExp(regStr, "g");

        return _string.replace(reg, '/');
    }
};
